import { isArray, isDayjs } from '../_util/is';
function getFormat(time) {
    return isDayjs(time) && time.format('HH:mm:ss');
}
export function isTimeArrayChange(prevTime, nextTime) {
    return (getFormat(prevTime[0]) !== getFormat(nextTime[0]) ||
        getFormat(prevTime[1]) !== getFormat(nextTime[1]));
}
export function getAvailableDayjsLength(value) {
    if (!value) {
        return 0;
    }
    if (isArray(value)) {
        if (isDayjs(value[0]) && isDayjs(value[1])) {
            return 2;
        }
        if (!isDayjs(value[0]) && !isDayjs(value[1])) {
            return 0;
        }
        return 1;
    }
    return 0;
}
